import { render, staticRenderFns } from "./AssignProxyTask.vue?vue&type=template&id=70f2ab05&scoped=true"
import script from "./AssignProxyTask.vue?vue&type=script&lang=js"
export * from "./AssignProxyTask.vue?vue&type=script&lang=js"
import style0 from "./AssignProxyTask.vue?vue&type=style&index=0&id=70f2ab05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f2ab05",
  null
  
)

export default component.exports